(function () {
  if (!document.querySelector(".section-news__slider")) {
    return;
  }

  var slide_news = tns({
    container: ".section-news__slider",
    responsive: {
      600: {
        items: 1,
      },
      1299: {
        items: 4,
      },
      1500: {
        items: 4,
      },
    },
    controlsPosition: "bottom",
    autoplayButtonOutput: false,
    nav: false,
    slideBy: 1,
    controlsContainer: "#customize-controls2",
    gutter: 35,
    autoplay: false,
    lazyload: true,
    loop: false,
  });
})(tns);
